module.exports = __webpack_public_path__ + "static/media/All Default.64dba16e.svg";